import React from "react";
import "../styles/footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      © {new Date().getFullYear()} Loyola College Vettavalam — All Rights Reserved.
    </footer>
  );
};

export default Footer;
